var apiHost = process.env.REACT_APP_API_HOST || '';
var buildApiUrl = function (path) {
    return "" + apiHost + path;
};
export { buildApiUrl };
